module.exports = "<header class=\"secondary\">\n  <ng-content select=\"[header-left]\"></ng-content>\n  <ng-content select=\"[header-right]\"></ng-content>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/programming-header/programming-header.component.html
// module id = 1536
// module chunks = 2